export default {
  parse (queryString) {
    if (!queryString || !queryString.slice(1)) return {}
    const isQuery = queryString.slice(0, 1) === '?'
    if (!isQuery) return
    const newStr = queryString.slice(1)
    const queryList = newStr.split('&')
    let queryObj = {}
    queryList.forEach(item => {
      const idx = item.indexOf('=')
      if (idx > 0) {
        const key = item.slice(0, idx)
        const val = item.slice(idx + 1)
        queryObj[key] = val
      }
    })
    return queryObj
  },
  /**
   *
   * @param {*} queryString 基本为loaction.search 问号后面的参数
   * @param {*} keys url中要移除的参数
   */
  removeKeys (queryString, keys) {
    let param = ''
    const paramObj = this.parse(queryString)
    for (let key in paramObj) {
      let flag = keys.filter(item => item === key)
      if (flag.length < 1) {
        param += `${key}=${paramObj[key]}&`
      }
    }
    param && (param = param.substring(0, param.length - 1))
    return param
  }
}



// WEBPACK FOOTER //
// ./src/helpers/queryString.js